export default __webpack_public_path__ + "canary_logo.cd7b29fa.svg";